import Route from '@ember/routing/route';
import RSVP from 'rsvp';
import { service } from '@ember/service';
import AbilitiesService from 'donor-elf-web/services/abilities';
import type NavbarSettingsService from 'donor-elf-web/services/navbar-settings';
import type Settings from 'donor-elf-web/services/settings';
import type Store from '@ember-data/store';
import type Transition from '@ember/routing/transition';
import type SessionService from 'ember-simple-auth/services/session';

export default class CoachingRoute extends Route {
  @service declare abilities: AbilitiesService;
  @service declare navbarSettings: NavbarSettingsService;
  @service declare session: SessionService;
  @service declare settings: Settings;
  @service declare store: Store;

  async beforeModel(transition: Transition) {
    await this.session.requireAuthentication(transition, 'login');

    this.navbarSettings.currentMenuLabel = 'coachingMenu';
    this.navbarSettings.rootMenuLabel = 'coachingMenu';
    this.navbarSettings.topNavbarComponent = 'top-navbar-coaching';
  }

  model() {
    return RSVP.hash({
      settings: this.settings.loadSettings('-1'),
      abilities: this.abilities.loadCoachingAbilities(),
    });
  }

  willTransition = (transition: Transition) => {
    const intentName = transition.to?.name || '';

    if (intentName.length > 0 && intentName.indexOf('coaching.') !== 0) {
      this.navbarSettings.currentMenuLabel = 'rootMenu';
      this.navbarSettings.rootMenuLabel = 'rootMenu';
    }
  };
}
